import React from 'react';

const CardCard = ({ card }) => {
    return (    
        <tr>
            <td>
                <div className="d-flex px-2 py-1">
                    <div>
                        <img src={"../assets/img/"+card.artwork} className="avatar avatar-sm me-3 border-radius-lg" alt="user1"/>
                    </div>
                    <div className="d-flex flex-column justify-content-center">
                        <h6 className="mb-0 text-sm">{card.name}</h6>
                        <p className="text-xs text-secondary mb-0">{card.description}</p>
                    </div>
                </div>
            </td>
            <td>
                <p className="text-xs font-weight-bold mb-0">{card.timeSaveMins}</p>
                <p className="text-xs text-secondary mb-0">Minutes</p>
            </td>
            <td className="align-middle text-center text-sm">
                <span className="badge badge-sm bg-gradient-success">{card.tags}</span>
            </td>
            <td className="align-middle text-center">
                <span className="text-secondary text-xs font-weight-bold">{card.id}</span>
            </td>
            <td className="align-middle">
                <a href="#" className="text-secondary font-weight-bold text-xs" data-toggle="tooltip" data-original-title="Edit user">
                    Edit
                </a>
            </td>
        </tr>
    );
}

export default CardCard;